import { graphql, useStaticQuery } from 'gatsby';

import { FeatureFlag, Query } from '../generated/graphql';
import { isDefined } from '../types/types';

export const useFeatureFlags = () => {
  const { allFeatureFlag } = useStaticQuery<Query>(
    graphql`
      {
        allFeatureFlag {
          edges {
            node {
              description
              isActive
              lastFetched
              modifiedDate
              name
              variations {
                T_A
                T_B
                T_C
              }
            }
          }
        }
      }
    `
  );

  const { edges } = allFeatureFlag;
  const featureFlags = edges
    .filter(isDefined)
    .map(edge => edge.node)
    .reduce((allFlags, flag) => {
      const { name } = flag;
      if (name) {
        allFlags.set(name, flag);
      }
      return allFlags;
    }, new Map<string, FeatureFlag>());
  return featureFlags;
};
